import { useQuery } from '@apollo/client';
import {
  FunctionComponent, useMemo,
} from 'react';
import { useParams } from 'react-router';

import DashboardWrap from '../../components/DashboardWrap';
import { cleanUpAdminSingleTransaction } from '../../utils/helpers';
import { GET_ADMIN_TRANSACTION_BY_ID } from '../../graphql/admin_queries';
import AdminDetailsHeader from '../../components/AdminDetailsHeader';
import TransactionRequestDetails from './TransactionRequestDetails';
import { ITransaction } from '../../interfaces/admin';

import './style.scss';
import UserDetailsCardCa from '../../components/UserDetailsCardCa';
import SummaryDetailsCover from '../../components/SummaryDetailsCover';
import PropertyDetailComp from '../../components/PropertyDetailComp';
import EmptyPageLoader from '../../components/EmptyPageLoader';

const TransactionDetail: FunctionComponent = () => {
  const { transactionId } = useParams<{ transactionId: string }>();
  const { data, loading } = useQuery<
    {
      getTransactionByIdCa: ITransaction;
    },
    { id: string }
  >(GET_ADMIN_TRANSACTION_BY_ID, { variables: { id: transactionId } });

  const transaction = useMemo(() => data?.getTransactionByIdCa, [data]);

  const payload: any = cleanUpAdminSingleTransaction(transaction);

  const indexFunction = (profileComponentName) => {
    switch (profileComponentName) {
    case 'Transaction detail':
      return 1;
    case 'Property detail':
      return 2;
    default:
      return 0;
    }
  };

  return (
    <DashboardWrap>
      <div className="transaction-details-loader" style={{ display: loading ? 'block' : 'none' }}>
        <EmptyPageLoader />
      </div>
      <div className="transaction-details-root" style={{ display: loading ? 'none' : 'block' }}>
        <SummaryDetailsCover>
          <div className="transaction-details-cover">
            <AdminDetailsHeader routeName="/transactions/all" />
          </div>
          <UserDetailsCardCa payload={payload} />
          <div className="transaction-details-card-root">

            <TransactionRequestDetails payload={payload} index={indexFunction('Transaction detail')} />

          </div>
          {payload?.property && (
          <div className="">
            <PropertyDetailComp payload={payload} index={indexFunction('Property detail')} />
          </div>
          )}
        </SummaryDetailsCover>
      </div>
    </DashboardWrap>
  );
};

export default TransactionDetail;
